import React, { createContext, useState, useEffect } from "react";

const ItemContext = createContext();

const ItemProvider = ({ children }) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [totalOption, setTotalOption] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [cart, setCart] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    // Calculate the total price whenever the cart changes
    const cartTotal = cart.reduce((acc, item) => {
      const quantity = item.item.quantity > 1 ? item.item.quantity : 1;
      const optionsTotal = item.item.options.reduce(
        (total, option) => parseFloat(total) + parseFloat(option.price),
        0
      );
      return acc + optionsTotal + parseFloat(item.item.amount) * quantity;
    }, 0);

    const total = cartTotal / 100;
    setTotalPrice(total); // Set the total price with two decimal places
    
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart, totalOption, totalPrice]);

  useEffect(() => {
    const savedCart = JSON.parse(localStorage.getItem("cart"));
    if (savedCart) {
      setCart(savedCart);
    }
  }, []);

  const submitOrder = (items, totalPrice, userInfo) => {
   
    setUserDetails(userInfo);
    setTotalPrice(totalPrice);
    setCart((prevCart) => [...prevCart, ...items]);
  };

  // Edit Cart based on cartItemId
  const updateCartItem = (oldItem, newItem) => {
    setCart((prevCart) => {
      const updatedCart = prevCart.map((cartItem) => {
        console.log(cartItem.cartItemId, oldItem.cartItemId)
        console.log("true?", cartItem.cartItemId === oldItem.cartItemId);
        return cartItem.cartItemId === oldItem.cartItemId ? newItem : cartItem;
      });
      console.log(updatedCart);
      setIsEditMode(false);
      return updatedCart;
    });
  };

  return (
    <ItemContext.Provider
      value={{
        selectedItems,
        totalPrice,
        submitOrder,
        setSelectedItems,
        totalOption,
        setTotalOption,
        setTotalPrice,
        userDetails,
        setUserDetails,
        cart,
        setCart,
        updateCartItem,
        setIsEditMode,
        isEditMode,
      }}
    >
      {children}
    </ItemContext.Provider>
  );
};

export { ItemContext, ItemProvider };
